import React from "react";

import styles from "./Nav.css";

export default class Nav extends React.Component {
  render() {
    return <div className={styles.nav}>{this.props.children}</div>;
  }
}
